import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-task-review-modal',
  templateUrl: './new-task-review-modal.component.html',
  styleUrls: ['./new-task-review-modal.component.scss']
})
export class NewTaskReviewModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
